import { makeStyles } from "@mui/styles";
import { Theme} from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "transparent",
  },
  headerCell: {
    color: theme.palette.gray80.main,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
  },
}));

export default useStyles;
